import React from 'react';

interface Props {
  iContactAppId: string | null;
}

export function IContactInstructions({ iContactAppId }: Props) {
  return (
    <div>
      <p>
        Buildout logs into your iContact account using your iContact login and a password you create just for
        Buildout. So connecting your iContact account is a two-step process. First, log in to iContact and create a
        password for Buildout, then enter your user ID and this password in the form below.
      </p>
      <h6>In iContact, Create a Password for Buildout</h6>
      <ol>
        <li>
          Log into iContact then go to{' '}
          <a href="https://app.icontact.com/icp/core/externallogin" rel="noreferrer" target="_blank">
            https://app.icontact.com/icp/core/externallogin
          </a>
        </li>
        <li>Enable Buildout by entering this Application ID: <code>{iContactAppId}</code></li>
        <li>Enter the password to use for Buildout. It should be different from your normal password.</li>
      </ol>
    </div>
  );
}
